// components/dashboard/EmergencyContact.jsx
import React from 'react';
import { Phone, User, Mail } from 'lucide-react';

const EmergencyContact = () => {
    const contactInfo = {
        name: 'Jean Dupont',
        role: 'Contact Principal',
        phone: '+227 XX XX XX XX',
        email: 'contact@email.com'
    };

    return (
        <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-semibold text-[#437011] flex items-center mb-6">
                <Phone className="w-6 h-6 mr-2" />
                Contact d'urgence
            </h2>
            <div className="p-4 bg-[#F4F8E9] rounded-lg">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                        <div className="p-2 bg-white rounded-full">
                            <User className="w-4 h-4 text-[#96B734]" />
                        </div>
                        <div>
                            <p className="font-medium text-[#437011]">{contactInfo.name}</p>
                            <p className="text-sm text-gray-600">{contactInfo.role}</p>
                        </div>
                    </div>
                    <button className="p-2 hover:bg-white rounded-full transition-colors">
                        <Phone className="w-5 h-5 text-[#96B734]" />
                    </button>
                </div>
                <div className="space-y-2">
                    <p className="text-sm text-gray-600 flex items-center">
                        <Phone className="w-4 h-4 mr-2 text-[#96B734]" />
                        {contactInfo.phone}
                    </p>
                    <p className="text-sm text-gray-600 flex items-center">
                        <Mail className="w-4 h-4 mr-2 text-[#96B734]" />
                        {contactInfo.email}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EmergencyContact;